// extracted by mini-css-extract-plugin
module.exports = {"two-column-image-container":"TwoColumnRow_two-column-image-container__MLViq","content":"TwoColumnRow_content__P577h"};